// skeleton/app/src/app/incident-dispute/dispute-signature/dispute-signature.component.ts

import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Output,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SignaturePad } from 'angular2-signaturepad';
import {
  ButtonSize,
  ButtonStyle,
  ButtonType,
} from 'src/app/shared/components/inputs/button/button.model';
import { ModalSize } from 'src/app/shared/components/view/modal/modal.model';
import {
  IDispute,
  IDisputeSignResponse,
} from 'src/app/shared/models/dispute/dispute.model';
import { IDisputeConfig } from 'src/app/shared/models/dispute/disputeConfig.model';
import { DisputeService } from 'src/app/shared/services/dispute.service';
import { GlobalsessionhandlerService } from 'src/app/shared/services/globalsessionhandler.service';
import { environment } from 'src/environments/environment';
import { StorageService } from 'src/app/shared/services/token-storage.service';
import { BaseHttpService } from 'src/app/shared/services/basehttp.service';
import { Constants } from 'src/app/shared/constants';

@Component({
  selector: 'app-dispute-signature',
  templateUrl: './dispute-signature.component.html',
  styleUrls: ['./dispute-signature.component.scss'],
  standalone: false,
})
export class DisputeSignatureComponent {
  disputeSignPopUpHeaderHtmlContent = environment.disputeSignPopUpHeaderHtmlContent;

  @Output() disputeSignResponse = new EventEmitter<IDisputeSignResponse>();

  dispute: IDispute;
  disputeConfig: IDisputeConfig;

  showError: boolean = false;
  loggedInUserMailId: string = '';
  selectedUser: string = '';
  showSignPopup: boolean = false;

  @ViewChild('canvasEl', { static: false, read: ElementRef }) canvasEl: ElementRef;
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;

  public signaturePadOptions: object = {
    minWidth: 2,
    maxWidth: 4,
    canvasWidth: 750,
    canvasHeight: 200,
    penColor: '#000000',
    backgroundColor: 'rgba(255,255,255,0)',
  };

  isSignDrawn: boolean = false;
  saveBtnText: string = 'OK';
  btnXlarge = ButtonSize.Medium;
  btnWithText = ButtonStyle.Textonly;
  btnRect = ButtonType.Rectangle;

  clearBtnText: string = 'CLEAR';
  modalText = 'Setup and sign';
  modalSize = ModalSize.CustomSignaturePopup;

  imageSrc: string = '';
  errorMessages: string[] = [];

  userSignRole: string = '';
  esignDate: string;

  OptionSelectedToDrawSign: boolean = true;
  OptionSelectedToTypeSign: boolean = false;

  showUserNameAsSign: boolean = false;
  userRoleDesc: string = '';
  userLoginName: string = '';

  private context: CanvasRenderingContext2D;
  private hasRenderedInitialText: boolean = false;

  isESignAllowed: boolean = true;
  isSSignAllowed: boolean = false;
  showImage: boolean = false;

  signresp: IDisputeSignResponse = {} as IDisputeSignResponse;
  constants: Constants = new Constants();

  constructor(
    public dialogRef: MatDialogRef<DisputeSignatureComponent>,
    private sessionHandleService: GlobalsessionhandlerService,
    private disputeService: DisputeService,
    @Inject(MAT_DIALOG_DATA) public data: { disputeInput: IDispute; disputeConfig: IDisputeConfig },
    private storage: StorageService,
    private baseHttpService: BaseHttpService
  ) {
    this.dispute = data.disputeInput;
    this.disputeConfig = data.disputeConfig;
  }

  close() {
    try {
      this.dialogRef.close(null);
    } catch (error) {
      this.logError('close', error);
    }
  }

  ok() {
    try {
      this.dialogRef.close(this.signresp);
    } catch (error) {
      this.logError('ok', error);
    }
  }

  ngAfterViewChecked() {
    try {
      if (
        this.OptionSelectedToTypeSign &&
        this.selectedUser?.length > 0 &&
        this.canvasEl?.nativeElement &&
        !this.hasRenderedInitialText
      ) {
        this.signTextChange(this.selectedUser);
        this.hasRenderedInitialText = true;
      }
    } catch (error) {
      this.logError('ngAfterViewChecked', error);
    }
  }

  private onCanvasReady(): void {
    try {
      if (this.OptionSelectedToTypeSign && this.selectedUser?.length > 0) {
        this.signTextChange(this.selectedUser);
      }
    } catch (error) {
      this.logError('onCanvasReady', error);
    }
  }

  ngAfterViewInit() {
    try {
      if (this.signaturePad) {
        this.signaturePad.clear();
        this.signaturePad.set('minWidth', 1);
        this.signaturePad.set('maxWidth', 2);
        this.signaturePad.set('backgroundColor', 'rgb(255, 255, 255)');
        this.signaturePad.set('penColor', 'rgb(0, 0, 0)');
      }

      this.onCanvasReady();
    } catch (error) {
      this.logError('ngAfterViewInit', error);
    }
  }

  ngOnInit() {
    try {
      console.log('DisputeSignatureComponent ngOnInit dispute', this.dispute);
      console.log('DisputeSignatureComponent ngOnInit disputeConfig', this.disputeConfig);

      this.getDisputeConfig();
      this.getUserDetails();
      this.setEsignDate();
      this.setDisputeSignDetailsOnLoad();
    } catch (error) {
      this.logError('ngOnInit', error);
    }
  }

  getUserDetails() {
    try {
      const loggedInUserName = this.sessionHandleService.getLoggedInUserName() || '';
      this.userLoginName = loggedInUserName.toUpperCase();

      const userName = loggedInUserName.split(',');
      this.userRoleDesc = this.storage.get('LoggedInUserTypeDesc') || '';
      this.loggedInUserMailId = this.storage.get('LoggedInuserMailId') || '';

      if (
        userName.length <= 0 ||
        !userName[0] ||
        userName[0].trim().length === 0 ||
        this.userRoleDesc === '' ||
        this.loggedInUserMailId === ''
      ) {
        this.getUserInfo();
      } else {
        this.autoFillUserName();
      }
    } catch (error) {
      this.logError('getUserDetails', error);
    }
  }

  getUserInfo() {
    try {
      this.baseHttpService.get(this.constants.getUser).subscribe({
        next: (result: any) => {
          try {
            if (result != null) {
              const fullName = result.fullName || '';
              const loginname = fullName.split(',');

              if (loginname.length > 1) {
                this.storage.set('LoggedInuserFirstName', loginname[1].trim());
                this.sessionHandleService.setLoggedInUserName(
                  `${loginname[1].trim()}, ${loginname[0].trim()}`
                );
              }

              this.storage.set('UserGroupId', result.userGroupId);
              this.storage.set('LoggedInUserTypeDesc', result.userTypeDesc);
              this.storage.set('LoggedInuserMailId', result.email);

              this.loggedInUserMailId = result.email || '';
              this.userRoleDesc = result.userTypeDesc || '';

              this.autoFillUserName();
            }
          } catch (error) {
            this.logError('getUserInfo next', error);
          }
        },
        error: (error) => {
          this.logError('getUserInfo', error);
        },
      });
    } catch (error) {
      this.logError('getUserInfo subscribe', error);
    }
  }

  private autoFillUserName(): void {
    try {
      const loggedInUserName = this.sessionHandleService.getLoggedInUserName() || '';
      const userName = loggedInUserName.split(',');

      if (userName.length > 1) {
        this.selectedUser = `${userName[1].trim()} ${userName[0].trim()}`;
      } else {
        this.selectedUser = loggedInUserName.trim();
      }
    } catch (error) {
      this.logError('autoFillUserName', error);
    }
  }

  getDisputeConfig() {
    try {
      if (
        this.disputeConfig != null &&
        this.disputeConfig.allowedSignTypes &&
        this.disputeConfig.allowedSignTypes.length > 0
      ) {
        this.isESignAllowed = this.disputeConfig.allowedSignTypes.includes('esign');
        this.isSSignAllowed = this.disputeConfig.allowedSignTypes.includes('ssign');
        this.OptionSelectedToDrawSign = this.isESignAllowed;
      }
    } catch (error) {
      this.logError('getDisputeConfig', error);
    }
  }

  setEsignDate() {
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const now = new Date();

      if (tz) {
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: tz,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }).formatToParts(now);

        const byType = parts.reduce((acc, p) => {
          if (p.type !== 'literal') {
            acc[p.type] = p.value;
          }
          return acc;
        }, {} as any);

        this.esignDate = `${byType.year}-${byType.month}-${byType.day}`;
      } else {
        const localNow = new Date();
        const year = localNow.getFullYear();
        const month = String(localNow.getMonth() + 1).padStart(2, '0');
        const day = String(localNow.getDate()).padStart(2, '0');
        this.esignDate = `${year}-${month}-${day}`;
      }
    } catch (error) {
      const localNow = new Date();
      const year = localNow.getFullYear();
      const month = String(localNow.getMonth() + 1).padStart(2, '0');
      const day = String(localNow.getDate()).padStart(2, '0');
      this.esignDate = `${year}-${month}-${day}`;

      this.logError('setEsignDate', error);
    }
  }

  setDisputeSignDetailsOnLoad() {
    try {
      this.imageSrc = null;

      if (this.dispute?.disputeSignResponse) {
        console.log(
          'DisputeSignatureComponent disputeSignResponse',
          this.dispute.disputeSignResponse
        );
      }
    } catch (error) {
      this.logError('setDisputeSignDetailsOnLoad', error);
    }
  }

  addSignBtnClick() {
    try {
      if (!this.selectedUser || this.selectedUser.trim().length === 0) {
        this.autoFillUserName();
      }

      if (!this.esignDate || this.esignDate === '') {
        this.setEsignDate();
      }

      this.hasRenderedInitialText = false;
      this.showSignPopup = true;
    } catch (error) {
      this.logError('addSignBtnClick', error);
    }
  }

  submitSign() {
    try {
      if (
        this.selectedUser.length === 0 ||
        this.userSignRole.length === 0 ||
        this.esignDate == null ||
        this.esignDate.length === 0
      ) {
        return;
      }

      if (this.signaturePad != undefined && !this.signaturePad.isEmpty()) {
        this.imageSrc = this.signaturePad.toDataURL();
        this.showImage = true;
      } else if (this.canvasEl != undefined && this.selectedUser.length > 0) {
        const context1 = this.canvasEl.nativeElement as HTMLCanvasElement;
        this.imageSrc = context1.toDataURL('image/png', 4);
        this.showImage = true;
        this.showUserNameAsSign = true;
      } else {
        this.imageSrc = '';
        this.clearSign();
      }

      this.signresp = {} as IDisputeSignResponse;
      this.signresp.name = this.selectedUser;
      this.signresp.role = this.userSignRole;
      this.signresp.email = this.loggedInUserMailId;
      this.signresp.date = this.formattedEsignDate;
      this.signresp.signType = this.OptionSelectedToDrawSign ? 'esign' : 'ssign';
      this.signresp.signatureData = this.imageSrc;
      this.signresp.consentAttestationText = this.disputeSignPopUpHeaderHtmlContent;

      this.showSignPopup = false;

      console.log('DisputeSignatureComponent sign response', this.signresp);
    } catch (error) {
      this.logError('submitSign', error);
    }
  }

  drawComplete() {
    try {
      this.isSignDrawn = !!(this.signaturePad && !this.signaturePad.isEmpty());
    } catch (error) {
      this.logError('drawComplete', error);
    }
  }

  drawStart() {
    try {
      this.isSignDrawn = !!(this.signaturePad && !this.signaturePad.isEmpty());
    } catch (error) {
      this.logError('drawStart', error);
    }
  }

  clearSign() {
    try {
      this.isSignDrawn = false;

      if (this.signaturePad != undefined) {
        this.signaturePad.clear();
        this.isSignDrawn = false;
      }
    } catch (error) {
      this.logError('clearSign', error);
    }
  }

  clearAndSignAgain() {
    try {
      this.showImage = false;
      this.imageSrc = null;
      this.OptionSelectedToDrawSign = true;
      this.OptionSelectedToTypeSign = false;
      this.autoFillUserName();
      this.userSignRole = '';
      this.setEsignDate();
      this.signaturePad?.clear();
      this.isSignDrawn = false;
      this.showUserNameAsSign = false;
      this.hasRenderedInitialText = false;
      this.showSignPopup = true;
    } catch (error) {
      this.logError('clearAndSignAgain', error);
    }
  }

  get formattedEsignDate(): string {
    try {
      if (!this.esignDate) {
        return '';
      }

      const [year, month, day] = this.esignDate.split('-');
      return `${month}/${day}/${year}`;
    } catch (error) {
      this.logError('formattedEsignDate', error);
      return '';
    }
  }

  closeSignPopup() {
    try {
      this.showSignPopup = false;
      this.userSignRole = '';
      this.autoFillUserName();
      this.setEsignDate();
      this.hasRenderedInitialText = false;
    } catch (error) {
      this.logError('closeSignPopup', error);
    }
  }

  drawSelect(e: any) {
    try {
      this.hasRenderedInitialText = e.checked === false ? false : true;
      this.OptionSelectedToDrawSign = e.checked;
      this.OptionSelectedToTypeSign = e.checked === true ? false : e.checked;

      this.signaturePad?.clear();
      this.isSignDrawn = false;
    } catch (error) {
      this.logError('drawSelect', error);
    }
  }

  textSelect(event: any) {
    try {
      this.OptionSelectedToDrawSign = false;
      this.clearSign();

      if (this.OptionSelectedToTypeSign) {
        this.hasRenderedInitialText = false;
        this.signTextChange(this.selectedUser);
      }
    } catch (error) {
      this.logError('textSelect', error);
    }
  }

  onKeyPress(event: any) {
    try {
      this.selectedUser = event.target.value;
      this.hasRenderedInitialText = false;
      this.signTextChange(this.selectedUser.trim());
    } catch (error) {
      this.logError('onKeyPress', error);
    }
  }

  signTextChange(selectedUser: string) {
    try {
      if (this.canvasEl?.nativeElement) {
        const canvas = this.canvasEl.nativeElement as HTMLCanvasElement;
        this.context = canvas.getContext('2d');

        if (this.context) {
          this.context.clearRect(0, 0, canvas.width, canvas.height);

          if (!selectedUser?.trim()) {
            return;
          }

          this.context.font = 'italic 24px "Segoe Script"';
          this.context.textAlign = 'center';
          this.context.textBaseline = 'middle';
          this.context.fillStyle = 'black';

          const formattedText = `/${selectedUser}/`;
          const textWidth = this.context.measureText(formattedText).width;
          const availableWidth = canvas.width - 40;

          if (textWidth > availableWidth) {
            const scaleFactor = availableWidth / textWidth;
            const fontSize = Math.floor(24 * scaleFactor);
            this.context.font = `italic ${fontSize}px "Segoe Script"`;
          }

          this.context.fillText(formattedText, canvas.width / 2, canvas.height / 2);
        }
      } else {
        console.log(
          'Canvas element not ready, skipping text render.',
          'CanvasEl:',
          !!this.canvasEl,
          'CanvasElement:',
          !!this.canvasEl?.nativeElement,
          'SelectedUser:',
          selectedUser
        );
      }
    } catch (error) {
      this.logError('signTextChange', error);
    }
  }

  private logError(methodName: string, error: any): void {
    console.error(`DisputeSignatureComponent ${methodName} failed.`, error);

    if (error?.message) {
      console.error(`DisputeSignatureComponent ${methodName} message:`, error.message);
    }

    if (error?.stack) {
      console.error(`DisputeSignatureComponent ${methodName} stack:`, error.stack);
    }

    if (error?.innerException) {
      console.error(
        `DisputeSignatureComponent ${methodName} innerException:`,
        error.innerException
      );
    }
  }
}